/* eslint-disable no-undef */
'use strict';

var _defineProperty = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _objectSpread = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _asyncToGenerator = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _classCallCheck = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _awaitAsyncGenerator = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");
var _wrapAsyncGenerator = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
var _require = require('./http/fetch'),
  _fetch = _require.fetch,
  Request = _require.Request,
  Headers = _require.Headers;
var _require2 = require('./http/error'),
  TimeoutError = _require2.TimeoutError,
  HTTPError = _require2.HTTPError;
var merge = require('merge-options').bind({
  ignoreUndefined: true
});
var _require3 = require('iso-url'),
  URL = _require3.URL,
  URLSearchParams = _require3.URLSearchParams;
var _require4 = require('native-abort-controller'),
  AbortController = _require4.AbortController;
var anySignal = require('any-signal');

/**
 * @typedef {import('stream').Readable} NodeReadableStream
 * @typedef {import('./types').HTTPOptions} HTTPOptions
 * @typedef {import('./types').ExtendedResponse} ExtendedResponse
 */

/**
 * @template TResponse
 * @param {Promise<TResponse>} promise
 * @param {number | undefined} ms
 * @param {AbortController} abortController
 * @returns {Promise<TResponse>}
 */
var timeout = function timeout(promise, ms, abortController) {
  if (ms === undefined) {
    return promise;
  }
  var start = Date.now();
  var timedOut = function timedOut() {
    var time = Date.now() - start;
    return time >= ms;
  };
  return new Promise(function (resolve, reject) {
    var timeoutID = setTimeout(function () {
      if (timedOut()) {
        reject(new TimeoutError());
        abortController.abort();
      }
    }, ms);

    /**
     * @param {(value: any) => void } next
     */
    var after = function after(next) {
      /**
       * @param {any} res
       */
      var fn = function fn(res) {
        clearTimeout(timeoutID);
        if (timedOut()) {
          reject(new TimeoutError());
          return;
        }
        next(res);
      };
      return fn;
    };
    promise.then(after(resolve), after(reject));
  });
};
var defaults = {
  throwHttpErrors: true,
  credentials: 'same-origin'
};
var HTTP = /*#__PURE__*/function () {
  /**
   *
   * @param {HTTPOptions} options
   */
  function HTTP() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, HTTP);
    /** @type {HTTPOptions} */
    this.opts = merge(defaults, options);
  }

  /**
   * Fetch
   *
   * @param {string | Request} resource
   * @param {HTTPOptions} options
   * @returns {Promise<ExtendedResponse>}
   */
  _createClass(HTTP, [{
    key: "fetch",
    value: function () {
      var _fetch2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resource) {
        var options,
          opts,
          headers,
          url,
          searchParams,
          transformSearchParams,
          json,
          abortController,
          signal,
          response,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              /** @type {HTTPOptions} */
              opts = merge(this.opts, options);
              headers = new Headers(opts.headers); // validate resource type
              if (!(typeof resource !== 'string' && !(resource instanceof URL || resource instanceof Request))) {
                _context2.next = 5;
                break;
              }
              throw new TypeError('`resource` must be a string, URL, or Request');
            case 5:
              url = new URL(resource.toString(), opts.base);
              searchParams = opts.searchParams, transformSearchParams = opts.transformSearchParams, json = opts.json;
              if (searchParams) {
                if (typeof transformSearchParams === 'function') {
                  // @ts-ignore
                  url.search = transformSearchParams(new URLSearchParams(opts.searchParams));
                } else {
                  // @ts-ignore
                  url.search = new URLSearchParams(opts.searchParams);
                }
              }
              if (json) {
                opts.body = JSON.stringify(opts.json);
                headers.set('content-type', 'application/json');
              }
              abortController = new AbortController(); // @ts-ignore
              signal = anySignal([abortController.signal, opts.signal]);
              _context2.next = 13;
              return timeout(_fetch(url.toString(), _objectSpread({}, opts, {
                signal: signal,
                timeout: undefined,
                headers: headers
              })), opts.timeout, abortController);
            case 13:
              response = _context2.sent;
              if (!(!response.ok && opts.throwHttpErrors)) {
                _context2.next = 19;
                break;
              }
              if (!opts.handleError) {
                _context2.next = 18;
                break;
              }
              _context2.next = 18;
              return opts.handleError(response);
            case 18:
              throw new HTTPError(response);
            case 19:
              response.iterator = function () {
                return fromStream(response.body);
              };
              response.ndjson = /*#__PURE__*/_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, chunk;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _iteratorAbruptCompletion = false;
                      _didIteratorError = false;
                      _context.prev = 2;
                      _iterator = _asyncIterator(ndjson(response.iterator()));
                    case 4:
                      _context.next = 6;
                      return _awaitAsyncGenerator(_iterator.next());
                    case 6:
                      if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                        _context.next = 18;
                        break;
                      }
                      chunk = _step.value;
                      if (!options.transform) {
                        _context.next = 13;
                        break;
                      }
                      _context.next = 11;
                      return options.transform(chunk);
                    case 11:
                      _context.next = 15;
                      break;
                    case 13:
                      _context.next = 15;
                      return chunk;
                    case 15:
                      _iteratorAbruptCompletion = false;
                      _context.next = 4;
                      break;
                    case 18:
                      _context.next = 24;
                      break;
                    case 20:
                      _context.prev = 20;
                      _context.t0 = _context["catch"](2);
                      _didIteratorError = true;
                      _iteratorError = _context.t0;
                    case 24:
                      _context.prev = 24;
                      _context.prev = 25;
                      if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                        _context.next = 29;
                        break;
                      }
                      _context.next = 29;
                      return _awaitAsyncGenerator(_iterator.return());
                    case 29:
                      _context.prev = 29;
                      if (!_didIteratorError) {
                        _context.next = 32;
                        break;
                      }
                      throw _iteratorError;
                    case 32:
                      return _context.finish(29);
                    case 33:
                      return _context.finish(24);
                    case 34:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[2, 20, 24, 34], [25,, 29, 33]]);
              }));
              return _context2.abrupt("return", response);
            case 22:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetch(_x2) {
        return _fetch2.apply(this, arguments);
      }
      return fetch;
    }()
    /**
     * @param {string | Request} resource
     * @param {HTTPOptions} options
     */
  }, {
    key: "post",
    value: function post(resource) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.fetch(resource, _objectSpread({}, options, {
        method: 'POST'
      }));
    }
    /**
     * @param {string | Request} resource
     * @param {HTTPOptions} options
     */
  }, {
    key: "get",
    value: function get(resource) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.fetch(resource, _objectSpread({}, options, {
        method: 'GET'
      }));
    }
    /**
     * @param {string | Request} resource
     * @param {HTTPOptions} options
     */
  }, {
    key: "put",
    value: function put(resource) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.fetch(resource, _objectSpread({}, options, {
        method: 'PUT'
      }));
    }
    /**
     * @param {string | Request} resource
     * @param {HTTPOptions} options
     */
  }, {
    key: "delete",
    value: function _delete(resource) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.fetch(resource, _objectSpread({}, options, {
        method: 'DELETE'
      }));
    }
    /**
     * @param {string | Request} resource
     * @param {HTTPOptions} options
     */
  }, {
    key: "options",
    value: function options(resource) {
      var _options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.fetch(resource, _objectSpread({}, _options, {
        method: 'OPTIONS'
      }));
    }
  }]);
  return HTTP;
}();
/**
 * Parses NDJSON chunks from an iterator
 *
 * @param {AsyncIterable<Uint8Array>} source
 * @returns {AsyncIterable<any>}
 */
var ndjson = /*#__PURE__*/function () {
  var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(source) {
    var decoder, buf, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, chunk, lines, i, l;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          decoder = new TextDecoder();
          buf = '';
          _iteratorAbruptCompletion2 = false;
          _didIteratorError2 = false;
          _context3.prev = 4;
          _iterator2 = _asyncIterator(source);
        case 6:
          _context3.next = 8;
          return _awaitAsyncGenerator(_iterator2.next());
        case 8:
          if (!(_iteratorAbruptCompletion2 = !(_step2 = _context3.sent).done)) {
            _context3.next = 25;
            break;
          }
          chunk = _step2.value;
          buf += decoder.decode(chunk, {
            stream: true
          });
          lines = buf.split(/\r?\n/);
          i = 0;
        case 13:
          if (!(i < lines.length - 1)) {
            _context3.next = 21;
            break;
          }
          l = lines[i].trim();
          if (!(l.length > 0)) {
            _context3.next = 18;
            break;
          }
          _context3.next = 18;
          return JSON.parse(l);
        case 18:
          i++;
          _context3.next = 13;
          break;
        case 21:
          buf = lines[lines.length - 1];
        case 22:
          _iteratorAbruptCompletion2 = false;
          _context3.next = 6;
          break;
        case 25:
          _context3.next = 31;
          break;
        case 27:
          _context3.prev = 27;
          _context3.t0 = _context3["catch"](4);
          _didIteratorError2 = true;
          _iteratorError2 = _context3.t0;
        case 31:
          _context3.prev = 31;
          _context3.prev = 32;
          if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
            _context3.next = 36;
            break;
          }
          _context3.next = 36;
          return _awaitAsyncGenerator(_iterator2.return());
        case 36:
          _context3.prev = 36;
          if (!_didIteratorError2) {
            _context3.next = 39;
            break;
          }
          throw _iteratorError2;
        case 39:
          return _context3.finish(36);
        case 40:
          return _context3.finish(31);
        case 41:
          buf += decoder.decode();
          buf = buf.trim();
          if (!(buf.length !== 0)) {
            _context3.next = 46;
            break;
          }
          _context3.next = 46;
          return JSON.parse(buf);
        case 46:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[4, 27, 31, 41], [32,, 36, 40]]);
  }));
  return function ndjson(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Stream to AsyncIterable
 *
 * @template TChunk
 * @param {ReadableStream<TChunk> | NodeReadableStream | null} source
 * @returns {AsyncIterable<TChunk>}
 */
var fromStream = function fromStream(source) {
  // Workaround for https://github.com/node-fetch/node-fetch/issues/766
  if (isNodeReadableStream(source)) {
    var iter = source[Symbol.asyncIterator]();
    return _defineProperty({}, Symbol.asyncIterator, function () {
      return {
        next: iter.next.bind(iter),
        return: function _return(value) {
          source.destroy();
          if (typeof iter.return === 'function') {
            return iter.return();
          }
          return Promise.resolve({
            done: true,
            value: value
          });
        }
      };
    });
  }
  if (isWebReadableStream(source)) {
    var reader = source.getReader();
    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _yield$_awaitAsyncGen, done, value;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
          case 1:
            if (!true) {
              _context4.next = 14;
              break;
            }
            _context4.next = 4;
            return _awaitAsyncGenerator(reader.read());
          case 4:
            _yield$_awaitAsyncGen = _context4.sent;
            done = _yield$_awaitAsyncGen.done;
            value = _yield$_awaitAsyncGen.value;
            if (!done) {
              _context4.next = 9;
              break;
            }
            return _context4.abrupt("return");
          case 9:
            if (!value) {
              _context4.next = 12;
              break;
            }
            _context4.next = 12;
            return value;
          case 12:
            _context4.next = 1;
            break;
          case 14:
            _context4.prev = 14;
            reader.releaseLock();
            return _context4.finish(14);
          case 17:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0,, 14, 17]]);
    }))();
  }
  if (isAsyncIterable(source)) {
    return source;
  }
  throw new TypeError('Body can\'t be converted to AsyncIterable');
};

/**
 * Check if it's an AsyncIterable
 *
 * @template {unknown} TChunk
 * @template {any} Other
 * @param {Other|AsyncIterable<TChunk>} value
 * @returns {value is AsyncIterable<TChunk>}
 */
var isAsyncIterable = function isAsyncIterable(value) {
  return typeof value === 'object' && value !== null && typeof /** @type {any} */value[Symbol.asyncIterator] === 'function';
};

/**
 * Check for web readable stream
 *
 * @template {unknown} TChunk
 * @template {any} Other
 * @param {Other|ReadableStream<TChunk>} value
 * @returns {value is ReadableStream<TChunk>}
 */
var isWebReadableStream = function isWebReadableStream(value) {
  return value && typeof /** @type {any} */value.getReader === 'function';
};

/**
 * @param {any} value
 * @returns {value is NodeReadableStream}
 */
var isNodeReadableStream = function isNodeReadableStream(value) {
  return Object.prototype.hasOwnProperty.call(value, 'readable') && Object.prototype.hasOwnProperty.call(value, 'writable');
};
HTTP.HTTPError = HTTPError;
HTTP.TimeoutError = TimeoutError;
HTTP.streamToAsyncIterator = fromStream;

/**
 * @param {string | Request} resource
 * @param {HTTPOptions} [options]
 */
HTTP.post = function (resource, options) {
  return new HTTP(options).post(resource, options);
};

/**
 * @param {string | Request} resource
 * @param {HTTPOptions} [options]
 */
HTTP.get = function (resource, options) {
  return new HTTP(options).get(resource, options);
};

/**
 * @param {string | Request} resource
 * @param {HTTPOptions} [options]
 */
HTTP.put = function (resource, options) {
  return new HTTP(options).put(resource, options);
};

/**
 * @param {string | Request} resource
 * @param {HTTPOptions} [options]
 */
HTTP.delete = function (resource, options) {
  return new HTTP(options).delete(resource, options);
};

/**
 * @param {string | Request} resource
 * @param {HTTPOptions} [options]
 */
HTTP.options = function (resource, options) {
  return new HTTP(options).options(resource, options);
};
module.exports = HTTP;